/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_cookie_advertising = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advertising cookies — Used by our advertising partners (e.g., Google AdSense) to serve relevant ads.`)
};

const es_privacy_cookie_advertising = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies publicitarias — Usadas por nuestros socios publicitarios (ej., Google AdSense) para mostrar anuncios relevantes.`)
};

const de_privacy_cookie_advertising = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Werbe-Cookies — Werden von unseren Werbepartnern (z.B. Google AdSense) verwendet, um relevante Werbung anzuzeigen.`)
};

const nl_privacy_cookie_advertising = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advertentiecookies — Gebruikt door onze advertentiepartners (bijv. Google AdSense) om relevante advertenties weer te geven.`)
};

const fr_privacy_cookie_advertising = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies publicitaires — Utilisés par nos partenaires publicitaires (ex. Google AdSense) pour diffuser des annonces pertinentes.`)
};

const it_privacy_cookie_advertising = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie pubblicitari — Utilizzati dai nostri partner pubblicitari (es. Google AdSense) per mostrare annunci pertinenti.`)
};

const pt_br2_privacy_cookie_advertising = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies de publicidade — Usados por nossos parceiros de publicidade (ex.: Google AdSense) para exibir anúncios relevantes.`)
};

const pt_privacy_cookie_advertising = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookies de publicidade — Utilizados pelos nossos parceiros publicitários (ex.: Google AdSense) para apresentar anúncios relevantes.`)
};

const ja_privacy_cookie_advertising = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`広告Cookie — 広告パートナー（例: Google AdSense）が関連広告を配信するために使用します。`)
};

const zh_privacy_cookie_advertising = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`广告Cookie — 由我们的广告合作伙伴（如Google AdSense）用于投放相关广告。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_cookie_advertising = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_cookie_advertising(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_cookie_advertising", locale)
	if (locale === "en") return en_privacy_cookie_advertising(inputs)
	if (locale === "es") return es_privacy_cookie_advertising(inputs)
	if (locale === "de") return de_privacy_cookie_advertising(inputs)
	if (locale === "nl") return nl_privacy_cookie_advertising(inputs)
	if (locale === "fr") return fr_privacy_cookie_advertising(inputs)
	if (locale === "it") return it_privacy_cookie_advertising(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_cookie_advertising(inputs)
	if (locale === "pt") return pt_privacy_cookie_advertising(inputs)
	if (locale === "ja") return ja_privacy_cookie_advertising(inputs)
	return zh_privacy_cookie_advertising(inputs)
};